import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import ShoppingBasketIcon from '../../../../../../../../../../../components/icons/ShoppingBasketIcon';
import Button from '../../../../../../../../../../../components/global/Button';
import CheckboxIcon from '../../../../../../../../../../../components/icons/CheckboxIcon';

const propTypes = {
  className: PropTypes.string,
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCheckout: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const EventCollageSizeSuccess = ({
  className,
  eventCollage,
  onCheckout,
  onDismiss,
}) => {
  const classes = classNames({
    [className]: !!className,
    'event-collage-success': true,
  });

  return (
    <div className={classes}>
      <div className="event-collage-success-header">
        <span className="event-collage-success-header-icon">
          <ShoppingBasketIcon />
          <CheckboxIcon />
        </span>
        <h4>{eventCollage?.custom_print?.name}</h4>
        <p>has been added to your cart!</p>
      </div>

      <p className="text-italic text-sm">
        You can change quantities or delete items from your cart.
      </p>

      <div className="event-collage-success-actions">
        <Button
          btnBlock
          btnSize="lg"
          onClick={onCheckout}
          btnStyle="success-vibrant"
          className="btn-checkout-event-collage-success"
        >
          <ShoppingBasketIcon />
          Check out now
        </Button>
        <Button
          btnBlock
          btnSize="lg"
          btnOutline
          onClick={onDismiss}
          className="btn-checkout-event-collage-success"
        >
          Continue shopping
        </Button>
      </div>
    </div>
  );
};

EventCollageSizeSuccess.propTypes = propTypes;

export default withModal(EventCollageSizeSuccess, {
  size: 'xs',
  hideHeader: true,
  dismissible: false,
  shouldCloseOnOverlayClick: false,
  className: 'event-collage-success-modal-wrap',
});
